import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import i18n from '~/i18n'
import ThreeColPaper from '../Components/ThreeColPaper'
import AutomationSteps from '~/Common-Objects/Automations/automationSteps'

export default function AuthenticateIntro({ domainId, setFlowStep, updateDomain = () => {} }) {
    const site = useSelector((state) => state.siteMaster)
    const [loading, setLoading] = useState(false)

    const goToNextStep = async (nextStepType) => {
        if (nextStepType == 'domainServicePicker') {
            await updateDomain({
                options: {
                    doneDnsIntro: true
                }
            })
        }
        setFlowStep(nextStepType)
    }

    if (loading) {
        return <LoadingIcons iconType='2' style={{ width: 32, height: 32, top: 0 }} />
    }

    return (
        <>
            <h2 className='mar-b15 text-center'>{i18n.t('company:domains.domainManagement.authenticateHeader')}</h2>
            <div className='mar-b40 text-center text-grey-800' style={{ lineHeight: '1.5' }}>
                {i18n.t('company:domains.domainManagement.authenticateIntro')}
            </div>
            <div style={{ width: '100%' }} className='text-sml mar-b40'>
                <div className='mar-b16'>{i18n.t('company:domains.domainManagement.authenticateHelpHeader')}</div>
                <div className='mar-b12' style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Icons icon='tickCircle' color='#319B90' style={{ width: '20px', height: '20px' }} />
                    <div>{i18n.t('company:domains.domainManagement.authenticateHelp1')}</div>
                </div>
                <div className='mar-b12' style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Icons icon='tickCircle' color='#319B90' style={{ width: '20px', height: '20px' }} />
                    <div>{i18n.t('company:domains.domainManagement.authenticateHelp2')}</div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Icons icon='tickCircle' color='#319B90' style={{ width: '20px', height: '20px' }} />
                    <div>{i18n.t('company:domains.domainManagement.authenticateHelp3')}</div>
                </div>
            </div>

            <ThreeColPaper
                style={{
                    boxShadow: '0px 1px 1px 0px rgba(23, 24, 25, 0.05)'
                }}
                col1Content={
                    <Icons icon='tickBreakingCircle' color='#7950EA' style={{ width: '20px', height: '20px' }} />
                }
                col2Content={
                    <div>
                        <div className='text-md mar-b4 text-heavy'>
                            {i18n.t('company:domains.domainManagement.authenticateCtaHeader')}
                        </div>
                        <div className='text-grey-800' style={{ fontSize: 13 }}>
                            {i18n.t('company:domains.domainManagement.authenticateCtaSub')}
                        </div>
                    </div>
                }
                col3Content={
                    <div style={{ minWidth: '120px' }}>
                        <Button
                            postHogTag='authenticate_domain_intro_button_start'
                            text={i18n.t('company:domains.domainManagement.authenticateCtaButton')}
                            className='button-primary'
                            iconRight={
                                <Icons
                                    icon='arrowRight'
                                    color='#FFFFFF'
                                    style={{ width: '20px', height: '20px' }}
                                />
                            }
                            onClick={() => {
                                setLoading(true)
                                goToNextStep('domainServicePicker')
                            }}
                        />
                    </div>
                }
            />

            <div
                className='text-sml mar-b40'
                style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '8px' }}
            >
                <Icons
                    icon='paperPlaneOutline'
                    color='#7950EA'
                    style={{ width: '20px', height: '20px' }}
                    onClick={() => goToNextStep('sendInstructions')}
                />
                <a
                    data-ph='authenticate_domain_intro_forward'
                    onClick={() => {
                        setLoading(true)
                        goToNextStep('sendInstructions')
                    }}
                >
                    {i18n.t('company:domains.domainManagement.sendInstructionsLink')}
                </a>
            </div>

            <div style={{ width: '100%' }}>
                <div className='text-md text-heavy'>{i18n.t('company:domains.domainManagement.resourcesHeader')}</div>
            </div>

            <>
                <AutomationSteps.Group title={undefined} style={{ width: '100%' }}>
                    {site.siteId == 1 && (
                        <AutomationSteps.Step
                            icon={
                                <Icons
                                    icon='bookOpen'
                                    color='#7950EA'
                                    style={{ width: '20px', height: '20px' }}
                                />
                            }
                            onClick={() => {
                                window.open(
                                    'https://transpond.io/support/deliverability-and-compliance/authenticating-your-email-domain',
                                    '_blank'
                                )
                            }}
                            title={
                                <div className='text-heavy'>
                                    {i18n.t('company:domains.domainManagement.guideTitle')}
                                </div>
                            }
                            subTitle={
                                <div style={{ fontSize: 13 }}>
                                    {i18n.t('company:domains.domainManagement.guideSub')}
                                </div>
                            }
                            ctaIcon={
                                <Icons
                                    icon='external'
                                    color='#595C61'
                                    style={{ width: '16px', height: '16px' }}
                                />
                            }
                            ctaWidth='20px'
                            iconHolderStyle={{ width: '20px', height: '20px' }}
                            postHogTag='authenticate_domain_intro_authentication_guide'
                        />
                    )}
                    <AutomationSteps.Step
                        icon={
                            <Icons
                                icon='questionCircleOutline'
                                color='#7950EA'
                                style={{ width: '20px', height: '20px' }}
                            />
                        }
                        onClick={() => {
                            window.open(`mailto:${site.supportEmail}`, '_blank')
                        }}
                        title={
                            <div className='text-heavy'>{i18n.t('company:domains.domainManagement.supportTitle')}</div>
                        }
                        subTitle={
                            <div style={{ fontSize: 13 }}>{i18n.t('company:domains.domainManagement.supportSub')}</div>
                        }
                        ctaIcon={
                            <Icons icon='external' color='#595C61' style={{ width: '16px', height: '16px' }} />
                        }
                        ctaWidth='20px'
                        iconHolderStyle={{ width: '20px', height: '20px' }}
                        postHogTag='authenticate_domain_intro_contact_support'
                    />
                </AutomationSteps.Group>
            </>
        </>
    )
}
